import { useRouteLoaderData } from 'react-router'
import type { loader as rootLoader } from '~/routes/_layout/index'

export function useShopContext() {
  const data = useRouteLoaderData<typeof rootLoader>('layout')
  if (!data) throw new Error('useShopContext must be used under the root layout')
  if (!('styling' in data) || !data.styling) {
    throw new Error('useShopContext: styling not available (archived webshop?)')
  }
  return data as typeof data & { styling: NonNullable<(typeof data)['styling']> }
}
